import { render, staticRenderFns } from "./mainNavigation.vue.html?vue&type=template&id=0f7aa178&"
import script from "./mainNavigation.ts?vue&type=script&lang=ts&"
export * from "./mainNavigation.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports